<template>
  <div class="sticky">
    <button class="exit" @click="this.$emit('update',false)">
      <svg width="10.606689" height="10.606445" viewBox="0 0 10.6067 10.6064" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <desc>
            Created with Pixso.
        </desc>
        <defs/>
        <path id="Vector" d="M5.3 4.12L9.42 0L10.6 1.17L6.48 5.3L10.6 9.42L9.42 10.6L5.3 6.48L1.17 10.6L0 9.42L4.12 5.3L0 1.17L1.17 0L5.3 4.12Z" fill="#050505" fill-opacity="1.000000" fill-rule="nonzero"/>
      </svg>

    </button>
    <div v-for="(filter, index) in filters" :key="index" class="filter-section">
      <div class="filter-header" @click="toggleFilter(index)" v-if="index === 'category' ||  index === 'bottles' ||  index === 'beverage'">
        <span>{{ titles[index].label }}</span>
        <svg 
          width="12.728027" 
          height="7.778076" 
          viewBox="0 0 12.728 7.77808" 
          fill="none" 
          xmlns="http://www.w3.org/2000/svg" 
          :class="{'rotated': !filter.open}"
        >
          <path id="Vector" d="M6.36 2.82L1.41 7.77L0 6.36L6.36 0L12.72 6.36L11.31 7.77L6.36 2.82Z" fill="#1D1D34" />
        </svg>
      </div>
      <div :class="['filter-body', { 'open': filter.open }]"
        :style="{
          opacity: filter.open ? 1 : 0,
          maxHeight: filter.open ? '500px' : '0px',
        }">
        <CategorySelect v-if="index === 'category'" :name="'category'" :categories="categoryData" v-model="filter.value" />
        <CategorySelect v-if="index === 'bottles'" :name="'bottles'" :categories="bottleData" v-model="filter.value" />
        <CategorySelect v-if="index === 'beverage'" :name="'beverage'" :categories="beverageData" v-model="filter.value" />
        <!-- <PriceRange v-if="index === 'tank' && maxTank" :max="maxTank" :min="minTank" @update="filter.value = $event"/>
        <YearFilter v-if="index === 'year' && maxYear" :max="maxYear" :min="minYear" @update="filter.value = $event"/> -->
      </div>
    </div>
  </div>
</template>

<script>
import CategorySelect from '../UI/Category/CategorySelect.vue';
import PriceRange from '../UI/Category/PriceRange.vue';
import YearFilter from '../UI/Category/YearFilter.vue';
import axios from "axios";
export default {
  components: {
    CategorySelect,
    PriceRange,
    YearFilter
  },
  props: {
    filters: [Array,Object],
  },
  data() {
    return {
      titles: {
          category: { label: 'Categories'},
          bottles: { label: 'Bottles'},
          beverage: { label: 'Beverage'},
          // tank: { label: 'Filter by Tank'},
          // year: {label: 'Filter by Year'}
      }, 
      categoryData: [],
      bottleData: [],
      beverageData: [],
    };
  },
  methods: {
      async getCategories() {
        let fData = new FormData();
        await axios.post("/get/category", fData)
            .then(resp => {
              this.categoryData = resp.data.data;
              this.bottleData = resp.data.bottle;
              this.beverageData = resp.data.beverage;
            })
            .catch(() => {
            })
            .finally(() => {
            });
      },
    toggleFilter(index) {
      // Открытие/закрытие фильтра по индексу
      this.filters[index].open = !this.filters[index].open;
    }
  },
  mounted () {
    this.getCategories();
  },
};
</script>
  
  
  <style scoped>
  .exit{
    display: none;
    width: 32px;
    height: 32px;
    background: rgb(222, 230, 234);
    border-radius: 100%;
    cursor: pointer;
  }
  .sticky{
    position: sticky;
    top: 90px;
  }
  .filter-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    color: rgb(5, 5, 5);
    font-size: 16px;
    font-weight: 500;
    line-height: 140%;
    text-align: left;
    margin-bottom: 24px;
  }
  
  /* Класс для поворота SVG */
  .rotated {
    transform: rotate(180deg);
    transition: transform 0.3s ease-in-out;
  }
  
  .filter-body {
  transition: opacity 0.3s ease, max-height 0.3s ease;
}
@media (max-width: 1024px) {
.sticky{
  display: none;
  position: fixed;
}
.sticky.show{
  display: block;
  position: fixed;
  width: 100%;
  background-color: white;
  z-index: 999;
  height: 100vh;
  top: 0;
  left: 0;
  padding: 24px;
  padding-top: 54px;
  overflow-y: auto;
  padding-bottom: 100px;
}
.exit{
  display: block;
  position: absolute;
  right: 16px;
  top: 16px;
}
}
  </style>
  